import {STRAPI_DEVELOPMENT, STRAPI_PRODUCTION} from '../../constants/Api';

export const currentUserWithAllData = (token) => {
  return new Promise((resolve, reject) => {
    fetch(
      process.env.NODE_ENV === 'production'
        ? `${STRAPI_PRODUCTION}/users/me`
        : `${STRAPI_DEVELOPMENT}/users/me`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    ).then(async (data) => {
      const {username, email} = await data.json();
      resolve({userId: username, email});
    });
  });
};

export const currentUser = (token) => {
  return new Promise((resolve, reject) => {
    fetch(
      process.env.NODE_ENV === 'production'
        ? `${STRAPI_PRODUCTION}/users/me`
        : `${STRAPI_DEVELOPMENT}/users/me`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    ).then(async (data) => {
      const {username, error, id, email} = await data.json();
      if (error) {
        reject(error);
      }

      resolve({userId: username, id, email});
    });
  });
};
